import { useToast } from '@/components/feedback/toast';
import { useRealtimeEvent } from '@/providers/realtime-provider';

/**
 * Tells the admin that Digital Matter would not take the FieldPro connector (story 112249).
 *
 * Display only: the backend owns the five ten-minute retries and the final SMS, the parameter
 * configuration stays saved, and the acceptance criteria forbid any in-app retry — so this offers
 * no action. Mounted in `<AppShell>` so it reaches the admin in whichever module they moved on to.
 */
export function useConnectorFailureToast(): void {
  const toast = useToast();

  useRealtimeEvent('connector-warning', ({ serialNumber }) => {
    toast.error({
      // Keyed per device: a repeat for the same serial updates the pill instead of stacking a
      // duplicate, while two different devices still get a toast each.
      key: `connector-sync-failed-${serialNumber}`,
      title: `Connector setup in Digital Matter failed for Device ${serialNumber}`,
    });
  });
}
